import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { AuthService } from '../../services/auth.service'

@Component({
  selector: 'albert-unauthorized',
  standalone: true,
  template: `
    <div class="flex flex-col items-center justify-center h-screen text-center p-4">
      <h1 class="text-3xl font-bold mb-4">Unauthorized</h1>
      <p class="text-xl mb-8">
        You do not have the required user group to use this application.
      </p>
      <button
        class="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
        (click)="logout()"
      >
        Logout and try another account
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnauthorizedComponent {
  private readonly authService = inject(AuthService)

  public logout(): void {
    this.authService.logout()
  }
}
